import { useContext } from 'react';
import { AuthContext } from './AuthContext.tsx';
import type { AuthContextValue } from './AuthContext.tsx';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within <AuthProvider>');
  }
  return ctx;
}
